<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <client-search
        :style="{ float: 'right' }"
        :select-data="selectData"
        is-show="true"
        @onSearch="onSearch"
        @onChange="onChange"
        @onChangecompany="onChangecompany"
        @editAndAdd="editAndAdd"
        @importShow="importShow"
      />
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: (total) => `共${total}条`,
        }"
        @change="changePage"
      >
        <template slot="hospitalName" slot-scope="text, record">
          <a-tooltip
            placement="bottomLeft"
            :title="record.name"
            color="#13c2c2"
          >
            <span class="ellipsis">{{ record.name }}</span>
          </a-tooltip>
        </template>

        <template slot="addressName" slot-scope="text, record">
          <a-tooltip
            placement="bottomLeft"
            :title="record.address"
            color="#13c2c2"
          >
            <span class="ellipsis">{{ record.address }}</span>
          </a-tooltip>
        </template>

        <template slot="operation" slot-scope="text, record">
          <a href="javascript:;" @click="() => editAndAdd(record)">编辑</a>
          <!-- <a-divider type="vertical" /> -->
          <!-- <popconfirm-button
            :text="record.data.status===1?'禁用':'启用'"
            :alert-title="record.data.status===1?'确定禁用？':'确定启用？'"
            @onDelete="() => onConfirm(record)"
          /> -->
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>

      <!-- 医院，药店 -->
      <hospital-modal
        ref="hospitalModalForm"
        :title="title"
        :maps="maps"
        :addrs="addrs"
        :createTime="createTime"
        :hospital-visible="hospitalVisible"
        :form-data="formData"
        @onCancel="onCancel"
      >
        <form-button
          :btn-is-loading="btnIsLoading"
          @onCancel="onCancel"
          @onSubmit="onSubmit"
        />
      </hospital-modal>
      <!-- 商业公司-->
      <business-modal
        ref="businessModalForm"
        :businessModalTitle="businessModalTitle"
        :maps="maps"
        :addrs="addrs"
        :createTime="createTime"
        :business-visible="businessVisible"
        :form-data="formData"
        @onCancelBusinessModal="onCancelBusinessModal"
      >
        <form-button
        :btn-is-loading="btnIsLoading"
          @onCancel="onCancelBusinessModal"
          @onSubmit="onSubmit('business')"
        />
      </business-modal>
      <a-modal
        class="client-modal-wrapper hospital-modal"
        :destroy-on-close="true"
        width="1400px"
        :mask-closable="false"
        :visible="ImportReadhospitalVisible"
        :footer="null"
        title="导入医院"
        @cancel="onCancel1"
      >
        <a-upload
          name="upload"
          style="margin-right: 20px"
          :with-credentials="false"
          :data="{ fileType: 'file' }"
          :action="`${uploadUrl}fileup/upload`"
          @change="(event) => importDoctors(event)"
        >
          <a-tooltip placement="bottom">
            <template slot="title">
              <span>提示：按照模板格式导入</span>
            </template>
            <a-button shape="round">
              <a-icon type="upload" /> 批量导入医院
            </a-button>
          </a-tooltip>
        </a-upload>
        <div class="upload-notice">
          支持上传xls和xlsx格式文件，不超过10M，<a
            href="javascript:;"
            @click="xiazai"
            >点击下载Excel模板</a
          >。请按模板格式录入数据，格式错误将导致导入失败。 【本次导入成功
          {{ successNum }} 条，失败 {{ failNum }} 条；已存在 {{ hadNum }} 条】
        </div>
        <div>
          <a-table
            :scroll="{ y: 500, x: 1100 }"
            :columns="columns1"
            :data-source="data1"
            :loading="loading1"
            :row-key="(record) => record.line"
            :pagination="false"
            class="yc"
          >
            <template slot="error_msg" slot-scope="text, record">
              <div v-if="record.error == true" style="color: red">
                {{ record.error_msg }}
              </div>
              <div v-if="record.error !== true">{{ record.error_msg }}</div>
            </template>
          </a-table>
        </div>
      </a-modal>
    </div>
  </div>
</template>
<script>
import {
  columns,
  columns1,
  hospitalFormData,
  businessFormData,
  drugstoreFormData,
  orgnizationFormData,
  serverhospitaModalFormData,
} from "./data/index";
import TableSearch from "./components/search";
import hospitalModal from "./modal/hospitalModal";
import businessModal from "./modal/businessModal";
import serverhospitaModal from "./modal/serverhospitaModal";
export default {
  components: {
    hospitalModal,
    clientSearch: TableSearch,
    serverhospitaModal,
    businessModal,
  },
  data() {
    return {
      successNum: "-",
      failNum: "-",
      hadNum: "-",
      ImportReadhospitalVisible: false,
      selectData: [
        { id: "", name: "所有类型" },
        { id: "0", name: "医院" },
        { id: "3", name: "商业" },
        // { id: "1", name: "药店" },
      ],
      columns,
      columns1,
      data: [],
      data1: [],
      pageSize: 10,
      current: 1,
      total: 0,
      pageSize1: 10,
      current1: 1,
      total1: 0,
      loading1: false,
      loading: false,
      hospitalVisible: false,
      shopSystemVisible: false,
      title: "",
      formData: [],
      maps: [],
      type: "",
      btnIsLoading: false,
      hospitalFormData: [],
      drugstoreFormData: [],
      businessFormData: [],
      serverhospitaModalFormData: [],
      orgnizationFormData,
      typeId: "",
      keyword: "",
      id: "",
      addrs: "",
      createTime:"",
      daoruid: 0,
      token: "",
      company_id: "",
      businessVisible: false,
      businessModalTitle: "",
    };
  },
  mounted() {
    this.getCompanyList();
    this.token = localStorage.getItem("token");
    this.hospitalFormData = hospitalFormData;
    this.businessFormData = businessFormData;
    this.drugstoreFormData = drugstoreFormData;
    this.serverhospitaModalFormData = serverhospitaModalFormData;

    // 获取表格数据

    if (this.$store.state.user.role === 1) {
      // this.hospitalFormData.unshift( {
      //   name: 'company_id',
      //   lable: '合作企业',
      //   lableCol: 4,
      //   wrapperCol: 18,
      // },);
      this.drugstoreFormData.unshift({
        name: "company_id",
        lable: "合作企业",
        lableCol: 4,
        wrapperCol: 18,
      });

      // this.orgnizationFormData.unshift( {
      //   name: 'company_id',
      //   lable: '企业名称',
      //   lableCol: 4,
      //   wrapperCol: 18,
      // },);
    }
  },
  methods: {
    // 获取合作企业
    async getCompanyList() {
      let result = await this.$http.post("/Company/getCooperationCompanyList");
      if (result.data.status === 1) {
        this.company_id = result.data.data.data_list[0].id;
        this.getTableData({
          page: this.current,
          pageSize: this.pageSize,
          type: this.typeId ? this.typeId : undefined,
          keyword: this.keyword,
          cooperation_company_id: this.company_id,
        });
      }
    },
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post("/Customer/getList", params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            status: item.status,
            name: item.name,
            address: item.address,
            type: item.type,
            province: item.province_txt,
            city: item.city_txt,
            data: item,
            dengji: item.hospital_grade_txt
              ? item.hospital_grade_txt + "" + item.hospital_level_txt
              : "-",
            create_time: this.$Format(item.create_time),
          };
          temp.push(obj);
        });
        this.data = temp;
      }
    },
    async xiazai() {
      window.open(
        `${this.uploadUrl}/fileup/downLoadImportExcel?name=hospital&token=${this.token}`
      );
    },
    async getTableData1(params) {
      this.loading1 = true;
      let result = await this.$http.post(
        "/customer/hospitalImportRead",
        params
      );
      if (result.data.status === 1) {
        this.loading1 = false;
        this.total1 = result.data.data.count;
        let data = result.data.data;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            line: item.line,
            cooperativeEnterprise: item.cooperativeEnterprise,
            hospitalName: item.hospitalName,
            province: item.province,
            city: item.city,
            grade: item.grade,
            address: item.address,
            lng: item.lng,
            lat: item.lat,
            error_msg: item.error_msg,
            error: item.error,
          };
          temp.push(obj);
        });
        this.data1 = temp;

        this.current = 1;
        this.getTableData({
          page: this.current,
          pageSize: this.pageSize,
          type: this.typeId ? this.typeId : undefined,
          keyword: this.keyword,
          cooperation_company_id: this.company_id,
        });
      }
    },
    // 搜索
    onSearch(value) {
      this.current = 1;
      this.keyword = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        type: this.typeId ? this.typeId : undefined,
        keyword: this.keyword,
        cooperation_company_id: this.company_id,
      });
    },
    onChangecompany(value) {
      console.log(value);
      this.current = 1;
      this.company_id = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        type: this.typeId ? this.typeId : undefined,
        keyword: this.keyword,
        cooperation_company_id: this.company_id,
      });
    },
    // 改变下拉框值
    onChange(value) {
      this.current = 1;
      this.typeId = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        type: this.typeId ? this.typeId : undefined,
        keyword: this.keyword,
        cooperation_company_id: this.company_id,
      });
    },
    // 编辑或新增
    editAndAdd(record) {
      // 商业公司
      if ((record.key && record.key == 3) || (record.type && record.type == 3)) {
        this.businessVisible = true;
      } else {
        // 非商业公司
        this.hospitalVisible = true;
      }

      if (record.key) {
        this.id = "";
        // 新增
        switch (record.key) {
          case "0":
            this.title = "新增医院客户";
            this.maps = [];
            this.addrs = "";
            this.type = "0";
            this.createTime = "";
            this.$nextTick(() => {
              this.formData = this.hospitalFormData;
              this.$refs.hospitalModalForm.$refs.basicForm.form.resetFields();
            });
            break;
          case "1":
            this.title = "新增药店客户";
            this.type = "1";
            this.$nextTick(() => {
              this.formData = this.drugstoreFormData;
              this.$refs.hospitalModalForm.$refs.basicForm.form.resetFields();
            });
            break;
          case "2":
            this.title = "新增机构客户";
            this.type = "2";
            this.$nextTick(() => {
              this.formData = this.orgnizationFormData;
              this.$refs.hospitalModalForm.$refs.basicForm.form.resetFields();
            });
            break;
          case "3":
            this.type = "3";
            this.businessModalTitle = "新增商业公司";
            this.maps = [];
            this.addrs = "";
            this.createTime = "";
            this.$nextTick(() => {
              this.formData = this.businessFormData;
              this.$refs.businessModalForm.$refs.basicForm.form.resetFields();
            });
            break;
        }
      } else {
        // 编辑
        let data1 = {
          company_id:
            this.$store.state.user.role === 1
              ? record.data.company_id
              : undefined,
          name: record.name,
          provinceCity: {
            province: record.data.province,
            city: record.data.city,
          },
          hospital_grade: record.data.hospital_grade,
          hospital_level: record.data.hospital_level,
          incharge: record.data.incharge,
          zip_code: record.data.zip_code,
          address: record.data.address,
          summary: record.data.summary,
          unique_feature: record.data.unique_feature,
          hospital_class: record.data.hospital_class,
          hospital_nature: record.data.hospital_nature,
          hospital_property_right_nature:
            record.data.hospital_property_right_nature,
          hospital_profit_nature: record.data.hospital_profit_nature,
          lat: record.data.lat,
          lng: record.data.lng,
        };

        let data2 = {
          company_id:
            this.$store.state.user.role === 1
              ? record.data.company_id
              : undefined,
          name: record.name,
          provinceCity: {
            province: record.data.province,
            city: record.data.city,
          },
          incharge: record.data.incharge,
          drugstore_kind: record.data.drugstore_kind,
          zip_code: record.data.zip_code,
          address: record.data.address,
          summary: record.data.summary,
          unique_feature: record.data.unique_feature,
        };
        let data3 = {
          company_id:
            this.$store.state.user.role === 1
              ? record.data.company_id
              : undefined,
          name: record.name,
          provinceCity: {
            province: record.data.province,
            city: record.data.city,
          },
          incharge: record.data.incharge,
          institution_kind: record.data.institution_kind,
          zip_code: record.data.zip_code,
          address: record.data.address,
          summary: record.data.summary,
          unique_feature: record.data.unique_feature,
        };

        let data4 = {
          name: record.name,
          provinceCity: {
            province: record.data.province,
            city: record.data.city,
          },
          address: record.data.address,
        };
        this.type = record.data.type;
        this.id = record.id;
        let data;
        if (record.type === 0) {
          this.title = "编辑医院客户";
          this.maps = [record.data.lng, record.data.lat];
          this.createTime = record.data.create_time;
          this.addrs = {
            addrs: record.data.address,
            lnglat: record.data.lng + "," + record.data.lat,
          };
          data = data1;
          this.formData = this.hospitalFormData;
        } else if (record.type === 1) {
          this.title = "编辑药店客户";
          data = data2;
          this.formData = this.drugstoreFormData;
        } else if (record.type === 3) {
          this.businessModalTitle = "编辑商业公司";
          this.maps = [record.data.lng, record.data.lat];
          this.createTime = record.data.create_time;
          this.addrs = {
            addrs: record.data.address,
            lnglat: record.data.lng + "," + record.data.lat,
          };
          data = data4;
          this.formData = this.businessFormData;
        } else {
          this.title = "编辑机构客户";
          data = data3;
          this.formData = this.orgnizationFormData;
        }

        this.$nextTick(() => {
          let fromForm = record.type == 3 ? this.$refs.businessModalForm : this.$refs.hospitalModalForm;
            fromForm.$refs.basicForm.form.setFieldsValue(data);
        });
      }
    },
    // 确定编辑或新增
    onSubmit(type) {
      this.btnIsLoading = true;
      let fromForm = type === "business" ? this.$refs.businessModalForm : this.$refs.hospitalModalForm;
      fromForm.$refs.basicForm.form.validateFields(async (err, values) => {
        console.log("onSubmit -> values", values);

        if (!err) {
          values.province = values.provinceCity.province;
          values.city = values.provinceCity.city;
          if (
            Object.prototype.toString.call(values.address) === "[object Object]"
          ) {
            values.lng = values.address.lnglat.split(",")[0];
            values.lat = values.address.lnglat.split(",")[1];
            values.address = values.address.addrs;
          } else {
            values.lng = this.addrs.lnglat.split(",")[0];
            values.lat = this.addrs.lnglat.split(",")[1];
          }

          values.path = `0,${values.provinceCity.province},${values.provinceCity.city}`;
          let result = await this.$http.post("/Customer/update", {
            type: this.type,
            id: this.id,
            ...values,
            cooperation_company_id: this.company_id,
          });
          this.btnIsLoading = false;
          if (result.data.status === 1) {
            this.$message.success("操作成功！");
            this.getTableData({
              page: this.current,
              pageSize: this.pageSize,
              type: this.typeId ? this.typeId : undefined,
              keyword: this.keyword,
              cooperation_company_id: this.company_id,
            });
            this.hospitalVisible = false;
            this.businessVisible = false;
          }
        }
      });
    },
    // 取消编辑/新增商业公司弹窗
    onCancelBusinessModal() {
      this.businessVisible = false;
    },
    // 取消编辑或新增
    onCancel() {
      this.hospitalVisible = false;
    },
    // 联系人管理
    handleContact(record) {
      this.$router.push({ path: "/client/contact", query: { id: record.id } });
    },
    importShow() {
      this.data1 = [];
      this.ImportReadhospitalVisible = true;
    },
    onCancel1() {
      this.ImportReadhospitalVisible = false;
    },
    async importDoctors(event) {
      console.log("importDoctors -> event", event);
      if (event.file.response && event.file.response.status === 0) {
        this.$message.warning(event.file.response.msg);
      }
      if (event.file.response && event.file.response.status === 1) {
        let id = event.file.response.data.id;
        this.daoruid = id;
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let res = await this.$http.post("/customer/hospitalImport", {
          id,
          cooperation_company_id: this.company_id,
        });
        console.log("importDoctors -> res", res);
        loading.close();
        if (res.data.status === 1) {
          this.successNum = res.data.data.successNum;
          this.failNum = res.data.data.failNum;
          this.hadNum = res.data.data.hadNum;
          this.getTableData1({
            page: this.current,
            pageSize: this.pageSize,
            id: id,
          });
          this.$message.success("操作成功！");
        }
      }
    },
    // 禁用 启用
    async onConfirm(record) {
      console.log("TCL: onConfirm -> record", record);
      let result = await this.$http.post("/Customer/setStatus", {
        id: record.id,
        status: record.status === 1 ? 0 : 1,
      });
      if (result.data.status === 1) {
        this.$message.success("操作成功！");
        // this.getTableData({page: pagination.current, pageSize: this.pageSize, type: this.typeId? this.typeId:undefined, keyword: this.keyword});
      }
    },
    // 删除
    async onDelete(record) {
      console.log("删除", record);
      let result = await this.$http.post("/customer/customerDel", {
        id: record.data.res_id,
      });
      console.log(result);

      if (result.data.status === 1) {
        this.$message.success("操作成功！");
        this.getTableData({
          page: this.current,
          pageSize: this.pageSize,
          type: this.typeId ? this.typeId : undefined,
          keyword: this.keyword,
          cooperation_company_id: this.company_id,
        });
        // this.getTableData({page: pagination.current, pageSize: this.pageSize, type: this.typeId? this.typeId:undefined, keyword: this.keyword});
      }
    },
    // 分页
    changePage(pagination) {
      this.current = pagination.current;
      this.getTableData({
        page: pagination.current,
        pageSize: this.pageSize,
        type: this.typeId ? this.typeId : undefined,
        keyword: this.keyword,
        cooperation_company_id: this.company_id,
      });
    },
    changePage1(pagination) {
      this.current1 = pagination.current;

      this.getTableData1({
        page: pagination.current,
        pageSize: this.pageSize,
        id: this.daoruid,
        cooperation_company_id: this.company_id,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.yc .ant-table-tbody > tr > td {
  padding: 10px 4px !important;
}
/deep/.yc .ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  padding-left: 4px !important;
  padding-right: 4px !important;
}
</style>